module.exports = __webpack_public_path__ + "img/Angry Gorilla Sport and Esport Mascot Logo_1.jpg";